/**
 * Validate form
 *
 * @param {{password, passwordConfirm}} values
 * @returns {Object}
 */
export function validate(values) {
  const errors = {}

  if (!values.password) {
    errors.password = 'Required'
  }
  if (!values.passwordConfirm) {
    errors.passwordConfirm = 'Required'
  }
  if (values.password !== values.passwordConfirm) {
    errors.passwordConfirm = "Password and Password Confirmation doesn't match"
  }

  return errors
}



// WEBPACK FOOTER //
// ./src/Containers/Form/ResetPassword/validate.js